<template>
  <div id="foot">
    <b-navbar fixed="bottom" type="dark" variant="info" :sticky="isSticky">
      <b-nav-text>Navbar text</b-nav-text>
    </b-navbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      isSticky: true
    };
  }
};
</script>
<style>
#foot {
  margin-top: 50px;
}
</style>
